<template>

  <ValidationObserver v-slot="{ invalid }">
    <vx-card :title="$t('course-outline.assessment')" class="mb-base" title-color="primary">

      <template slot="actions">
        <div class="inline-flex">
          <vx-tooltip :text="$t('general.add')">
            <vs-button
              @click="onAddClick"
              class="ml-2"
              color="primary" icon="icon-plus" icon-pack="feather" radius size="small"
              type="filled"></vs-button>
          </vx-tooltip>
        </div>
      </template>

      <li class="flex flex-inline justify-between w-full items-center">
        <div>
          <vs-chip color="primary" transparent>
            {{ $t('course-outline.assessment-short') }}
          </vs-chip>
        </div>

        <div class="vx-row items-center" v-if="showEditTotalScoreForm">
          <div class="vx-col sm:w-3/5">
            <ValidationProvider :name="$t('course-outline.full-score')" rules="required|numeric|min:0"
                                v-slot="{ errors }">
              <vs-input :placeholder="$t('course-outline.full-score')" @input="onPercentInput"
                        class="w-full" size="small"
                        v-model.number="courseOutline.totalPoint"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col sm:w-2/5">
            <vx-tooltip :text="$t('general.save')+$t('course-outline.full-score')">
              <vs-button :disabled="local.isProcessing || invalid"
                         @click.prevent="onSaveTotalScoreClick" color="dark" icon="icon-save"
                         icon-pack="feather" size="small"
                         type="border">
              </vs-button>
            </vx-tooltip>
          </div>
        </div>

        <div class="vx-row items-center" v-else>
          <div class="vx-col sm:w-2/3 p-0 m-0">
            <vs-chip class="pr-0 p-0 m-0" color="primary" transparent>
              <span>{{ $t('course-outline.full-score') }}</span>
              <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">{{ courseOutlineCompute.totalPoint}}
              </vs-chip>
            </vs-chip>
          </div>
          <div class="vx-col sm:w-1/3">
            <vx-tooltip :text="$t('general.edit')+$t('course-outline.full-score')">

              <vs-button :disabled="local.isProcessing"
                         @click.prevent="onEditTotalScoreClick" color="dark" icon="icon-edit"
                         icon-pack="feather" size="small"
                         type="border">
              </vs-button>
            </vx-tooltip>
          </div>
        </div>

        <vs-chip color="primary" transparent>
          {{ $t('exam-upload.header.score') }}
        </vs-chip>
      </li>
      <!--EDIT FORM-->
      <div v-if="showEditForm">
        <vs-divider/>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider :name="$t('live-class-schedule.no')" rules="required|numeric" v-slot="{ errors }">
              <label class="text-sm">{{$t('live-class-schedule.no')}}</label>
              <vs-input v-model="courseOutlineAssessmentEdit.seq"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-col w-full mb-3">
          <ValidationProvider :name="$t('course-outline.assessment-short')" rules="required" v-slot="{ errors }">
            <label class="text-sm opacity-75">{{ $t('course-outline.assessment-short') + '*' }}</label>
            <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      :options="assessmentsCompute"
                      class="mb-4 md:mb-0"
                      label="nameLocal"
                      selectOnTab
                      v-model="selectedAssessment">
            </v-select>
            <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('course-outline.percent')" rules="required|numeric" v-slot="{ errors }">
              <vs-input :label="$t('course-outline.percent') + ' *'" @input="onPercentInput"
                        class="w-full"
                        v-model.number="courseOutlineAssessmentEdit.percent"/>
              <span class="text-danger text-sm" v-show="showExceedLimitScore">{{ $t('course-outline.exceed-limit-score') }}</span>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('course-outline.score')" rules="required|numeric" v-slot="{ errors }">
              <vs-input :disabled="true" :label="$t('course-outline.score') + ' *'"
                        class="w-full"
                        v-model.number="courseOutlineAssessmentEdit.score"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>

        <!-- Actions Button -->
        <div class="vx-row pt-2">
          <div class="vx-col w-full">
            <vs-button :disabled="local.isProcessing || invalid || showExceedLimitScore"
                       @click.prevent="onSaveClick">
              {{ $t('general.save') }}
            </vs-button>

            <vs-button @click.prevent="onCancelClick" class="ml-2" color="warning"
                       type="border">
              {{ $t('general.cancel') }}
            </vs-button>
          </div>
        </div>


      </div>
      <!--LIST ITEMS-->
      <div v-else>
        <li
          :key="assessment.id"
          class="flex flex-inline justify-between items-center w-full px-3 pl-0" v-for="assessment in courseOutlineAssessments"
        >
          <div class="flex-1 flex justify-start items-start">


            <vs-avatar :text="`${assessment.seq}`" class="bg-primary w-5 h-5 text-sm mr-2 p-2"/>
            <span class="text-sm mt-1">
                  {{ assessment.assessment.nameLocal }}
                </span>

            <feather-icon @click="onEditClick(assessment)" class="ml-2"
                          icon="EditIcon"
                          svgClasses="w-5 h-5 hover:text-primary cursor-pointer stroke-current"/>
            <feather-icon @click="onDeleteClick(assessment)" class="ml-2"
                          icon="TrashIcon"
                          svgClasses="w-5 h-5 hover:text-primary cursor-pointer stroke-current"/>
          </div>
          <div class="flex w-30 justify-between">
                <span class="w-16 text-right">
                  {{ assessment.percent }}%
                </span>
            <span class="w-16 text-right">
                  {{ assessment.score }}
                </span>
          </div>
        </li>
      </div>

    </vx-card>

  </ValidationObserver>

</template>

<script>
  import Assessment from '@/store/modules/common-data/assessment/index';
  import CourseOutlineAssessment from '@/store/modules/courses/course-outline-assessment/index';
  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import {state} from "../data";
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";
  import vSelect from 'vue-select';
  import {showStateNotification} from "@/utils/notification";
  import {confirmDelete} from '@/utils/dialogs';
  import * as _ from 'lodash';

  if (!state.store.Assessment) state.registerModule(`Assessment`, Assessment);
  if (!state.store.CourseOutlineAssessment) state.registerModule(`CourseOutlineAssessment`, CourseOutlineAssessment);
  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapAssessmentActions,
  } = createNamespacedHelpers(`Assessment`);
  const {
    mapActions: mapCourseOutlineAssessmentActions,
  } = createNamespacedHelpers(`CourseOutlineAssessment`);
  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);

  const {
    mapFields: mapAssessmentFields,
  } = createHelpers({
    getterType: `Assessment/getField`,
    mutationType: `Assessment/updateField`,
  });
  const {
    mapFields: mapCourseOutlineAssessmentFields,
  } = createHelpers({
    getterType: `CourseOutlineAssessment/getField`,
    mutationType: `CourseOutlineAssessment/updateField`,
  });
  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    props: {
      courseOutline: Object
    },
    components: {
      vSelect,
    },
    data() {
      return {
        store: state.store,
        local: state.local,

        courseOutlineAssessmentEdit: state.local.courseOutlineAssessmentEdit,

        assessments: [],
        selectedAssessment: null,

        showEditForm: false,
        showEditTotalScoreForm: false,
        showExceedLimitScore: false,
      }
    },
    computed: {
      ...mapAssessmentFields({assessmentProcessing: 'processing'}),
      ...mapCourseOutlineAssessmentFields({
        courseOutlineAssessmentProcessing: 'processing'
        , courseOutlineAssessmentSuccess: 'success', courseOutlineAssessmentError: 'error'
      }),
      ...mapCourseOutlineFields({
        courseOutlineProcessing: 'processing'
        , courseOutlineSuccess: 'success', courseOutlineError: 'error'
      }),
      courseOutlineAssessments() {
        return this.courseOutline ? this.courseOutline.courseOutlineAssessments : [];
      },
      courseOutlineCompute() {
        return this.courseOutline ? this.courseOutline : {};
      },
      assessmentsCompute() {
        return this.assessments;
      }
    },
    watch: {
      assessmentProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineAssessmentProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineAssessmentSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      courseOutlineAssessmentError: async function (data) {
        showStateNotification(this.$vs, data);
      },
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapAssessmentActions({
        getAssessments: 'getAssessments',
      }),
      ...mapCourseOutlineAssessmentActions({
        addCourseOutlineAssessment: 'addCourseOutlineAssessment',
        updateCourseOutlineAssessment: 'updateCourseOutlineAssessment',
        deleteCourseOutlineAssessment: 'deleteCourseOutlineAssessment',
      }),
      ...mapCourseOutlineActions({
        updateCourseOutline: 'updateCourseOutline',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onAddClick() {
        if(this.courseOutline.totalPoint === 0 || this.courseOutline.totalPoint === null){
          this.showEditTotalScoreForm = true;
        }else{
          this.showEditForm = !this.showEditForm;

          if (this.showEditForm) {
            this.courseOutlineAssessmentEdit.id = null;
            this.courseOutlineAssessmentEdit.seq = this.courseOutline.courseOutlineAssessments.length + 1;
            this.courseOutlineAssessmentEdit.percent = 0;
            this.courseOutlineAssessmentEdit.score = 0;
            this.selectedAssessment = null;

            this.showEditTotalScoreForm = false;
          }
          this.showExceedLimitScore = false;
        }

      },
      async onEditClick(tr) {
        this.showEditForm = !this.showEditForm;

        if (this.showEditForm) {

          this.selectedAssessment = tr.assessment;
          this.courseOutlineAssessmentEdit.id = tr.id;
          this.courseOutlineAssessmentEdit.seq = tr.seq;
          this.courseOutlineAssessmentEdit.percent = tr.percent;
          this.courseOutlineAssessmentEdit.score = tr.score;
        }
        this.showExceedLimitScore = false;
      },
      async onSaveClick() {
        let payload = {
          assessmentId: this.selectedAssessment.id,
          seq: this.courseOutlineAssessmentEdit.seq,
          percent: this.courseOutlineAssessmentEdit.percent,
          score: this.courseOutlineAssessmentEdit.score,
        }

        let result;
        if (this.courseOutlineAssessmentEdit.id) {
          payload['id'] = this.courseOutlineAssessmentEdit.id;
          result = await this.updateCourseOutlineAssessment(payload);
        } else {
          payload['courseOutlineId'] = this.courseOutline.id;
          result = await this.addCourseOutlineAssessment(payload);
        }
        if (result) {
          result = JSON.parse(JSON.stringify(result))

          if (!payload.id) {
            this.courseOutline.courseOutlineAssessments.push(result);
          } else {
            const index = this.courseOutline.courseOutlineAssessments.findIndex(item => {
              return item.id === result.id
            });
            this.courseOutline.courseOutlineAssessments[index] = result;
          }

          this.courseOutline.courseOutlineAssessments = this.sortAssessment(this.courseOutline.courseOutlineAssessments);


          this.showEditForm = false;
        }

      },
      onEditTotalScoreClick() {
        this.showEditTotalScoreForm = !this.showEditTotalScoreForm;

        if (this.showEditTotalScoreForm) {
          this.showEditForm = false;
        }
      },
      async onSaveTotalScoreClick() {
        let payload = {
          id: this.courseOutline.id,
          courseOutlineInput: {
            totalPoint: this.courseOutline.totalPoint,
          }
        }
        await this.updateCourseOutline(payload);

        //adjust score
        if(this.courseOutline.courseOutlineAssessments && this.courseOutline.courseOutlineAssessments.length > 0){
          this.courseOutline.courseOutlineAssessments = this.courseOutline.courseOutlineAssessments.map(item => {
            let totalPoint = this.courseOutline.totalPoint
            let score = (totalPoint * item.percent) / 100;
            return {
              ...item,
              score: parseInt(score.toFixed(0)),
            }
          });
        }

        this.showEditTotalScoreForm = false;
      },
      async onCancelClick() {
        this.showEditForm = false;
        this.showEditTotalScoreForm = false;
      },
      async onDeleteClick(item) {
        await confirmDelete(this.$vs, this.removeCourseOutlineAssessment, {id: item.id});
      },
      onPercentInput() {
        this.calculatePercentToScore(this.courseOutlineAssessmentEdit.percent);
        this.checkSumTotalScore();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      calculatePercentToScore(percent) {
        if(_.isNumber(percent)){
          let totalPoint = this.courseOutline.totalPoint
          let score = (totalPoint * percent) / 100;
          this.courseOutlineAssessmentEdit.score = parseInt(score.toFixed(0));
        } else {
          this.courseOutlineAssessmentEdit.score = null;
        }
      },
      checkSumTotalScore() {
        let totalPoint = this.courseOutline.totalPoint
        let sum = this.courseOutlineAssessmentEdit.score;
        this.courseOutline.courseOutlineAssessments.forEach(item => {
          if(item.id !== this.courseOutlineAssessmentEdit.id){
            sum += item.score;
          }
        })
        if (sum > totalPoint) {
          this.courseOutlineAssessmentEdit.percent = 0;
          this.courseOutlineAssessmentEdit.score = 0;
          this.showExceedLimitScore = true;
        }else{
          this.showExceedLimitScore = false;
        }
      },
      async removeCourseOutlineAssessment(payload) {
        let result = await this.deleteCourseOutlineAssessment(payload);

        if (result) {
          const index = this.courseOutline.courseOutlineAssessments.findIndex(item => item.id === result.id);
          this.courseOutline.courseOutlineAssessments.splice(index, 1);

          this.courseOutline.courseOutlineAssessments = this.sortAssessment(this.courseOutline.courseOutlineAssessments);


        }
      },
      sortAssessment(assessment){
        return _.sortBy(assessment, [function(item) { return item.seq; }]);
      },
      async initData() {
        if (!this.assessments || this.assessments.length === 0) {
          this.assessments = await this.getAssessments();
        }
      },
    },
    async mounted() {
      await this.initData();
    }
  }
</script>

<style scoped>

</style>
